import React, { useEffect } from 'react';
import { IColorwayProductData, IVariant, TUserSelections } from '../../types/PDP';
import { bopisState } from './bopisState';
import { observer } from 'mobx-react-lite';
import { StoreLocatorPDP } from '../StoreLocator/StoreLocatorPDP';
import { reaction } from 'mobx';
import { customerLocationState } from '../StoreLocator/customerLocationState';
import { storeLocatorSidebarState } from '../StoreLocator/storeLocatorSidebarState';
import { fireBOPISDataLayerEvent } from 'src/scripts/utils/gtm-data-layer';
import { transformPdpDataToBopisAnalyticsVariant } from './bopisUtils';
import { ShippingCountryState } from 'src/scripts/utils/shipping';
import { BopisAnalyticsData } from './bopisTypes';

let BopisContainer = ({
  selectedVariant,
  product,
  userSelections,
  shouldShowOmniPdpExperience = false,
}: {
  selectedVariant: IVariant | undefined;
  product: IColorwayProductData;
  userSelections: TUserSelections;
  shouldShowOmniPdpExperience?: boolean;
}) => {
  const userSelectedSize = userSelections[0].Size;

  useEffect(() => {
    if (selectedVariant && selectedVariant.sku) bopisState.fetchStoresDataPdp(selectedVariant, true); // single tile fetch
    const disposeCustomerLocationChangeOnPdpReaction = reaction(
      () => [customerLocationState.coordinates, storeLocatorSidebarState.isOpen],
      () => {
        if (selectedVariant && selectedVariant.sku) bopisState.fetchStoresDataPdp(selectedVariant);
      }
    );

    // necessary because state value is init. as null and updated with value from local storage
    // no user action involved in first run so it should be excluded
    let isFirstRun = true;
    const disposeBopisStoreSelectionReaction = reaction(
      () => bopisState.storeSelection,
      (storeSelection) => {
        if (isFirstRun) {
          isFirstRun = false;
          return; // skip the first run
        }
        const countryCode = ShippingCountryState.countryCode;
        const bopisAnalyticsVariant =
          selectedVariant && product?.title
            ? transformPdpDataToBopisAnalyticsVariant(selectedVariant, product)
            : undefined;

        fireBOPISDataLayerEvent({
          countryCode,
          page: 'PDP' as BopisAnalyticsData['page'],
          isSidebar: true,
          variants: bopisAnalyticsVariant ? [bopisAnalyticsVariant] : [],
          eventName: 'bopis_store_update_event',
        });
      }
    );

    return () => {
      disposeBopisStoreSelectionReaction();
      disposeCustomerLocationChangeOnPdpReaction();
    };
  }, [selectedVariant, product]);

  return (
    <StoreLocatorPDP
      title={'Buy Online, Pickup in Store'}
      userSelectedSize={userSelectedSize}
      storeLocatorType={'bopis'}
      isLoading={bopisState.isFetchingData}
      shouldShowOmniPdpExperience={shouldShowOmniPdpExperience}
    />
  );
};

BopisContainer = observer(BopisContainer);
export { BopisContainer };
